import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useInView } from 'react-intersection-observer';
import cc from 'classcat';
import Customer from '@outdoor-voices/ui/dist/utils/Customer';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import css from './Recommendations.module.scss';
import CollectionLoading from '../CollectionLoading';
import Loader from './Loader';
import { VISITOR_ID } from '../../config/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Recommendations = function Recommendations(_ref) {
  var full = _ref.full,
      inline = _ref.inline,
      id = _ref.id,
      title = _ref.title,
      variantIds = _ref.variantIds;
  var customer = new Customer();

  var _useInView = useInView({
    rootMargin: '350px 0px',
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var titleNode = /*#__PURE__*/_jsx("h2", {
    className: css.title,
    children: title
  });

  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.full, full), _defineProperty({}, css.inline, inline)]),
    ref: ref,
    children: [!inView && /*#__PURE__*/_jsxs(_Fragment, {
      children: [titleNode, /*#__PURE__*/_jsx(CollectionLoading, {
        fourUp: true
      })]
    }), inView && /*#__PURE__*/_jsx(Loader, {
      id: id,
      title: titleNode,
      visitorId: customer.getGA() || VISITOR_ID,
      variantIds: variantIds
    })]
  });
};

Recommendations.defaultProps = {
  full: false,
  inline: false,
  variantIds: []
};
Recommendations.propTypes = {
  full: PropTypes.bool,
  inline: PropTypes.bool,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  variantIds: PropTypes.arrayOf(PropTypes.number)
};
export default /*#__PURE__*/memo(Recommendations);